import styled from 'styled-components';
import React, { FC } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { Alert, Typography as T } from '@dev/ee-components';
import { Link } from '@material-ui/core';

import { links } from '@/services/dictionaries/links';
import { useSecurity } from '@/services/hooks/useSecurity';

const DialogContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    .MuiCheckbox-root {
        padding: 4px 9px;
    }
    .MuiInputBase-root {
        margin-bottom: 16px;
    }
    .MuiAlert-root {
        padding-bottom 16px;
        border-color: #fff
    }
`;
const WrongContactFile: FC = (): JSX.Element => {
    const { t } = useTranslation();
    const { isReseller } = useSecurity();
    return (
        <DialogContainer>
            <Alert severity="error" body={t('filedoesnotcontainemail')} />
            {!isReseller && (
                <T variant="body1">
                    {t('findoutmoreaboutuploadingfiles')}
                    <Link href={links.contactUpload} rel="noreferrer" target="_blank">
                        {t('here')}.
                    </Link>
                </T>
            )}
        </DialogContainer>
    );
};

export default withTranslation()(WrongContactFile);
